var _path;
/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
import { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
class IconQuizStatsDeviationLine extends Component {
  constructor(...args) {
    super(...args);
    this.ref = null;
    this.handleRef = el => {
      const elementRef = this.props.elementRef;
      this.ref = el;
      if (typeof elementRef === 'function') {
        elementRef(el);
      }
    };
  }
  render() {
    return _jsx(SVGIcon, {
      ...this.props,
      name: "IconQuizStatsDeviation",
      viewBox: "0 0 1920 1920",
      elementRef: this.handleRef,
      children: _path || (_path = _jsx("path", {
        d: "M960 1807.059c-467.125 0-847.059-379.934-847.059-847.059 0-467.125 379.934-847.059 847.059-847.059 467.125 0 847.059 379.934 847.059 847.059 0 467.125-379.934 847.059-847.059 847.059M960 0C430.645 0 0 430.645 0 960s430.645 960 960 960 960-430.645 960-960S1489.355 0 960 0m169.412 1047.902c0 107.181-87.19 194.485-194.485 194.485h-62.795c-107.294 0-194.485-87.304-194.485-194.485v-175.85c0-107.18 87.19-194.371 194.485-194.371h62.795c107.294 0 194.485 87.19 194.485 194.372v175.85ZM960 567.224c-8.358-.677-16.49-2.484-25.073-2.484h-62.795c-169.525 0-307.426 137.788-307.426 307.313v175.85c0 169.524 137.901 307.425 307.426 307.425h62.795c169.525 0 307.426-137.901 307.426-307.426v-175.85c0-74.089-27.445-141.289-71.266-194.371h240.678V564.74H960v2.484Z",
        fillRule: "evenodd"
      }))
    });
  }
}
IconQuizStatsDeviationLine.glyphName = 'quiz-stats-deviation';
IconQuizStatsDeviationLine.variant = 'Line';
IconQuizStatsDeviationLine.displayName = 'IconQuizStatsDeviationLine';
IconQuizStatsDeviationLine.allowedProps = [...SVGIcon.allowedProps];
export default IconQuizStatsDeviationLine;
export { IconQuizStatsDeviationLine };